module.exports = __webpack_public_path__ + "img/tg_01 (4).aaccdcec.jpg";